export default "__VITE_ASSET__CWVrY1UM__"